import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { normalizeSettingsForShowAll } from './shared'

export const bookyearEndDefinition = {
  type: filters.BOOKYEAR_END,
  nameKey: 'bookyear_end',
  ledgerRequired: false,

  comparisonModes() {
    return [
      ...CompareMixin.computed.isComparisonMode(),
      ...CompareMixin.computed.showAllComparisonMode(),
    ]
  },

  activeSubtitle(settings) {
    if (settings.comparisonMode === CompareMixin.TYPES.SHOW_ALL) {
      return I18n.t('companies_overview.filters.comparison_modes.show_all')
    }

    return `${settings.endDate}`
  },

  normalizeSettings(settings) {
    return normalizeSettingsForShowAll(settings, 'endDate', null)
  },

  serializeSettings(settings) {
    return {
      end_date: settings.endDate,
      comparison_mode: settings.comparisonMode,
    }
  },

  deserializeSettings(params) {
    return {
      endDate: params.end_date,
      comparisonMode: params.comparison_mode,
    }
  },
}
